import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/site";
import Seo from "@/components/Seo";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo
        title="Catering Services in Naples, Bonita Springs & Fort Myers | K.O Chef & Catering"
        description="Explore our catering services across Southwest Florida: wedding catering, corporate catering, private chef experiences, cocktail parties, BBQ, holiday and luxury event catering."
        path="/services"
      />
      <PageHero overline="Catering Services" title="Cuisine for Every Occasion"
        subtitle="Ten signature service offerings, each crafted to elevate your event."
        image="https://images.unsplash.com/photo-1576842546422-60562b9242ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="py-20 md:py-28">
        <div className="container-lux grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.08}>
              <Link to={`/services/${s.slug}`} className="group block relative overflow-hidden h-80" data-testid={`service-card-${s.slug}`}>
                <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute inset-0 p-7 flex flex-col justify-end">
                  <div className="flex items-center justify-between">
                    <h3 className="text-2xl font-light text-white">{s.title}</h3>
                    <ArrowUpRight className="w-5 h-5 text-gold opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" />
                  </div>
                  <p className="text-sm text-gold mt-1">{s.tag}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
